module.exports = __webpack_public_path__ + "media/svg/flechenewsletter-57992228.svg";